// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"58":"c3f46460","722":"d2b0d3a0","767":"c10e3187"}[chunkId] + ".css";
};